module.exports = __webpack_public_path__ + "static/media/wood_bg.1824045e.jpg";